module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABLklEQVR4AWOgD5hqgIr0GaaAEJwLl0LVMFmXYZI2wxRdhil6TNMMGUEiOkA2UATIQNEAUe29JbflzGzHDSlhO8tyDnW0n5uXsr/Rb1tBw6kZQduLgNrQNRQe6dn16HjJsf7K45M6z82feGlZ1/kFqfub5l3fAJRiRLOBcbKO79a8lbd3dZ1bUHdy2rq7e6deXll5fHLx0b6e84saTk1nnmaEooFpqqHd+qTwneVA0mNzlsmqSMXF3iaro6zXJhisDDdfE8s0VR/D05O0GCaoMUzUYJioDiInaQNFIAx0T8ODj2OGGf9sG77Z1ryzrHlmWQERkME41RBnsMosdPfbmg/0jPeWHM/N2R6bMouP9gK5QKuw2mAADHWwA6AIyAYazzbDFIsNuJE+SkwPSgAAioygi0+/TRwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SA.png
// module id = 1255
// module chunks = 0